<template>
    <tr :class="`${isEditRequested || isResolveRequested || isAddRequested || isDeleteRequested ? 'edit-row' : ''}`">
        <td class="align-top">
            <div class="form-group mb-0" v-if="isEditRequested || isAddRequested">
                <TypeaheadInput
                    :getData="getProblemsList"
                    :value="selectedProblem"
                    placeholder="Search for Problem"
                    :init-value="selectedProblem"
                    :disabled="isEditRequested"
                    v-on:valueChanged="selectedProblemChanged"
                />
            </div>
            <span v-else>
                <span v-if="problem?.description">{{ problem.description }}</span>
                <small v-else><i class="text-default">Not Available</i></small>
            </span>
        </td>
        <td class="align-top">
            <div class="form-group mb-0" v-if="isEditRequested || isAddRequested">
                <DatePicker :getDate="handleDateChange">
                    <div class="input-group date datepickerInput">
                        <input
                            name="startDate"
                            type="text"
                            class="form-control"
                            placeholder="MM/DD/YYYY"
                            :value="formatDateInput(problem?.onsetDate)"
                            @change="handleDate"
                            autocomplete="off"
                        />
                        <div class="input-group-addon input-group-append">
                            <div class="input-group-text">
                                <i class="fa fa-calendar"></i>
                            </div>
                        </div>
                    </div>
                </DatePicker>
            </div>
            <EmptyTextHandler :text="problem?.onsetDate" v-else />
        </td>
        <td>
            <EmptyTextHandler :text="problem?.lastAddressedOn" />
        </td>
        <td class="align-top text-center">
            <div class="form-check form-check-inline pt-3" v-if="isEditRequested || isAddRequested">
                <input
                    type="checkbox"
                    class="form-check-input ms-5"
                    id="is-present-on-admission"
                    :checked="problem.isPresentOnAdmission"
                    @change="handleIsPresentOnAdmission()"
                />
                <label class="form-check-label" for="is-present-on-admission">
                    <span></span>
                </label>
            </div>
            <span v-else>{{ problem.isPresentOnAdmission ? "Yes" : "No" }}</span>
        </td>
        <td class="text-end" v-if="!isEditRequested && !isResolveRequested && !isAddRequested && !isDeleteRequested">
            <button
                class="btn table-btn btn-outline-info me-1"
                @click="moveProblemUp(index, index - 1)"
                v-if="!first"
                v-tooltip="{ title: 'Move Problem Up' }"
            >
                <i class="fas fa-chevron-up"></i>
            </button>
            <button
                class="btn table-btn btn-outline-info me-1"
                @click="moveProblemDown(index, index + 1)"
                v-if="!last"
                v-tooltip="{ title: 'Move Problem Down' }"
            >
                <i class="fas fa-chevron-down"></i>
            </button>
            <button class="btn table-btn btn-outline-info" @click="openResolveProblem(index)">Resolve</button>
            <button class="btn table-btn btn-outline-info" @click="openEditProblem()">
                <i class="fas fa-edit"></i>
            </button>
            <button class="btn table-btn btn-outline-danger" @click="openDeleteProblem()">
                <i class="fas fa-trash-alt"></i>
            </button>
        </td>
        <td class="button-cell text-end" v-if="isEditRequested">
            <button type="button" class="btn table-btn btn-outline-success" @click="saveEditProblem()">Add</button>
            <button type="button" class="btn table-btn btn-outline-secondary" @click="cancelEditProblem()">
                Cancel
            </button>
        </td>
        <td class="button-cell text-end" v-if="isAddRequested">
            <button type="button" class="btn table-btn btn-outline-success" @click="save()">Add</button>
            <button type="button" class="btn table-btn btn-outline-secondary" @click="cancelSaveNewProblem()">
                Cancel
            </button>
        </td>
        <td class="text-end" v-if="isResolveRequested">
            <i>Problem Resolution in Progress</i>
        </td>
        <td :colspan="columns" class="p-2 text-end" v-if="isDeleteRequested">
            <TablePrompt
                ok-text="Yes, Delete"
                name="delete"
                :ok="deleteProb"
                :cancel="cancelDeleteRequest"
                :message="deleteMessage"
                cancel-text="No"
                :include-yes="false"
            />
        </td>
    </tr>
    <tr v-if="isResolveRequested" class="row-no-hover edit-row">
        <td :colspan="columns" class="p-2 edit">
            <div class="d-flex flex-column align-items-center">
                <div class="form-group w-25 mb-2">
                    <label for="resolution-date"> Resolution Date </label>
                    <DatePicker :options="resolveDatePickerOptions" :getDate="handleDateChange">
                        <div class="input-group date datepickerInput">
                            <input
                                name="resolvedDate"
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="MM/DD/YYYY"
                                :value="formatDateInput(resolvedDate)"
                                @change="handleDate"
                                autocomplete="off"
                                date-format-only
                            />
                            <div class="input-group-addon input-group-append">
                                <div class="input-group-text">
                                    <i class="fa fa-calendar"></i>
                                </div>
                            </div>
                        </div>
                    </DatePicker>
                </div>
                <div>
                    <button class="btn btn-xs btn-outline-primary me-1" @click="saveResolveProblem(index)">Save</button>
                    <button class="btn btn-xs btn-outline-secondary" @click="cancelResolveProblem(index)">
                        Cancel
                    </button>
                </div>
            </div>
        </td>
    </tr>
</template>

<script lang="ts" src="./ProblemsTableRow.ts"></script>
